
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/design-system/trust-pilot-widgets",
      function () {
        return require("private-next-pages/design-system/trust-pilot-widgets.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/design-system/trust-pilot-widgets"])
      });
    }
  